import angular, { IQService } from 'angular'
import moment from 'moment'
import templateUrl from './events-rep-assignment-container.component.html'
import './events-rep-assignment-container.less'
import { TimeSlotDecorator } from "../time-slot-decorator.service";
import { sortIcdOfficeByOwner } from '../../../core/services/data-services/icd-office.service';
import { ScheduleEventAssignedStatus, SiteModuleEnum } from "../../../core/services/data-services";
import { ScheduleEventDetailModal } from '../shared/schedule-event-detail.component';

export const EventsRepAssignmentContainerComponent = {
    controller: EventsRepAssignmentContainerController,
    templateUrl
}

function EventsRepAssignmentContainerController($q: IQService, $uibModal, apexApiUrl, utilityService, eventHostService,
    scheduleEventService, divisionService, employeeService, icdOfficeService, scheduleEventTimeSlotService) {
    'ngInject'

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    const recentsLocalStorageKey = "apexEventsSchedulingRecentEmployees";
    vm.$onInit = $onInit;
    vm.loaded = false;
    vm.scheduleEvents = [];
    vm.employeeOptions = createEmployeeOptions();
    vm.filters = { view: 'schedule' };
    vm.onChangeDivision = onChangeDivision;
    vm.onChangeIcdOffice = onChangeIcdOffice;
    vm.onChangeFilters = onChangeFilters;
    vm.divisions = [];
    vm.icdOffices = [];
    vm.employees = [];
    vm.pristineEmployees = [];
    vm.onCreateTimeSlot = onCreateTimeSlot;
    vm.onMoveTimeSlot = onMoveTimeSlot;
    vm.onChangeCalendar = onChangeCalendar;
    vm.onChangeSearchEmployee = onChangeSearchEmployee;
    vm.onDeleteTimeSlot = onDeleteTimeSlot;
    vm.onDragStart = onDragStart;
    vm.onDragEnd = onDragEnd;

    vm.scheduleActions = [{
        label: () => "Event Details",
        enabled: () => true,
        action: onViewDetails
    }, {
        label: () => "Event Sales",
        enabled: () => vm.filters.division && vm.filters.division.UseRSSchedule,
        action: schedule => window.location.href = "rsschedule/edit/" + schedule.id
    }];
    const timeSlotDecorator = new TimeSlotDecorator({
        warnAboutUnassigned: true
    });
    vm.calendar = {
        mode: "week",
        startDate: moment().startOf("isoWeek").toDate(),
        endDate: moment().endOf("isoWeek").toDate()
    };

    function $onInit() {
        initializePage();
    }

    function onViewDetails(scheduleEvent) {
        const detail = scheduleEventService.retrieveScheduleEvent(scheduleEvent.id)
            .then(detail => {
                // Hydrate with schedule event details
                return hydrateScheduleEvent(detail);
            });

        utilityService.showLoadingUntilResolved(detail);

        $uibModal.open({
            ...ScheduleEventDetailModal,
            resolve: {
                scheduleEvent: detail
            }
        });
    }

    function initializePage() {

        vm.loaded = false;
        utilityService.showLoading();
        const loadInitialData = loadDivisions()
            .then(loadIcdOffices)
            .then(function () {
                return loadScheduleEvents();
            })
            .then(function () {
                return loadOfficeEmployees();
            }).then(function () {
                return loadRecentEmployees();
            });

        loadInitialData
            .then(function () {
                vm.loaded = true;
            })
            .catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function loadOfficeEmployees() {
        if (!vm.filters.icdOffice || !vm.filters.division) {
            return $q.resolve([]);
        }

        const icdOffices = []
        vm.scheduleEvents.forEach(function (event) {
            icdOffices.push(...event.offices);
        });

        const distinctOffices = icdOffices.map(function (office) {
            return office.IcdOfficeID;
        }).filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
        const requests = distinctOffices.map(function (office) {
            return employeeService.retrieveEmployees({
                DivisionID: vm.filters.division.Id,
                IcdOfficeID: office
            }).then(function (employees) {
                employees.forEach(function (employee) {
                    employee.IcdOfficeID = office;
                    employee.IcdOffice = vm.icdOffices.filter(function (icdOffice) {
                        return icdOffice.Id === office
                    })[0];
                    employee.EmployeeLogo = apexApiUrl + "/employees/" + employee.Id + "/profile/image";
                });
                return employees;
            });
        });
        return $q.all(requests).then(function (v) {
            vm.employees = Array.prototype.concat.apply([], v);
            vm.pristineEmployees = angular.copy(vm.employees)
            distributeEmployees();
            return vm.employees;
        });
    }

    function distributeEmployees() {
        vm.rosterEmployees = vm.employees.filter(function (employee) {
            return vm.filters.icdOffice.Id === employee.IcdOfficeID;
        });
        vm.sharedEmployees = vm.employees.filter(function (employee) {
            return vm.filters.icdOffice.Id !== employee.IcdOfficeID;
        });
    }

    function loadIcdOffices() {
        return icdOfficeService.retrieveIcdOffices({
            divisionID: vm.filters.division ? vm.filters.division.Id : null, ModuleID: 28
        })
            .then(function (icdOffices) {
                vm.icdOffices = icdOffices.sort(sortIcdOfficeByOwner);
                vm.icdOffices.forEach(formatIcdOffice);
                vm.filters.icdOffice = vm.icdOffices[0]
                return vm.icdOffices;
            });
    }

    function loadDivisions() {
        return divisionService.retrieveDivisions({
            ModuleID: SiteModuleEnum.EventsScheduling
        }).then(divisions => {
            vm.divisions = divisions
            vm.filters.division = vm.divisions[0]
            // Update the event host list passively.
            loadEventHosts();
            return vm.filters.division;
        });
    }

    function loadEventHosts() {
        if (!vm.filters.division) {
            return $q.resolve([]);
        }
        return eventHostService.retrieveEventHosts({
            divisionID: vm.filters.division.Id
        }).then(eventHosts => vm.eventHosts = eventHosts.map(p => ({
            ...p,
            Text: `${p.HostName} - ${p.HostLocationName}`
        })));
    }

    function formatIcdOffice(office) {
        office.OwnerClientName = office.OwnerName + " - " + office.IcdCorporationName;
    }

    function loadScheduleEvents() {
        if (!vm.filters.icdOffice || !vm.filters.division) {
            return $q.resolve([]);
        }
        const param = generateQueryParameter();

        return scheduleEventTimeSlotService
            .retrieveOfficeScheduleEventTimeSlots(vm.filters.icdOffice.Id, param)
            .then(groupTimeSlotsByScheduleEvent)
            .then(function (scheduleEvents) {
                vm.pristineScheduleEvents = angular.copy(scheduleEvents)
                vm.scheduleEvents = scheduleEvents.map(mapScheduleEvents);
                return vm.scheduleEvents
            })
    }

    function hydrateScheduleEvent(detail) {
        const eventHostLoaded = eventHostService.retrieveEventHost(detail.EventHostID)
            .then(eventHost => detail.EventHost = eventHost);

        return $q.all([eventHostLoaded])
            .then(() => detail);
    }

    function groupTimeSlotsByScheduleEvent(timeSlots) {
        return timeSlots.reduce((ag, timeSlot) => {
            let scheduleEvent = ag.dict[timeSlot.ScheduleEvent.ScheduleEventID];
            if (!scheduleEvent) {
                scheduleEvent = {
                    ...timeSlot.ScheduleEvent,
                    TimeSlots: []
                };
                ag.dict[scheduleEvent.ScheduleEventID] = scheduleEvent;
                ag.events.push(scheduleEvent);
            }
            // Clone the time slot, but remove the schedule event property.
            scheduleEvent.TimeSlots.push({
                TimeSlotAssignmentID: timeSlot.TimeSlotAssignmentID === 0 ? null :
                    timeSlot.TimeSlotAssignmentID,
                StartDateTime: timeSlot.StartDateTime,
                EndDateTime: timeSlot.EndDateTime,
                Employee: timeSlot.Employee
            });

            return ag;
        }, { events: [], dict: {} }).events;
    }

    function mapScheduleEvents(scheduleEvent) {
        const eventNames = [
            scheduleEvent.HostLocationName
                ? `${scheduleEvent.HostName} (${scheduleEvent.HostLocationName})`
                : scheduleEvent.HostName,
            scheduleEvent.Program
        ].filter(p => p && p.trim())
            .join(" - ");
        const offices = scheduleEvent.ScheduleEventOffices.filter(function (office) {
            return office.AssignedStatus === ScheduleEventAssignedStatus.Accepted;
        });
        return {
            id: scheduleEvent.ScheduleEventID,
            name: eventNames,
            offices: offices,
            description: `${moment(scheduleEvent.StartDate).format("MMM DD")}–`
                + `${moment(scheduleEvent.EndDate).format("MMM DD")}`,
            readOnly: true,
            timeSlots: scheduleEvent.TimeSlots.map(function (timeSlot) {
                const isOffDate = isOffDay(moment(timeSlot.StartDateTime).toDate(), scheduleEvent.OffDates);
                const style = timeSlotDecorator.decorateTimeSlotColor(timeSlot);
                const description = timeSlot.Employee
                    ? `${timeSlot.Employee.FirstName} ${timeSlot.Employee.LastName}`
                    : "Unassigned";
                if (isOffDate) {
                    style.backgroundColor = "#f44242";
                    style.borderColor = "#f44242";
                    style.color = "#FFFFFF";
                }
                return {
                    id: timeSlot.TimeSlotAssignmentID,
                    startDateTime: timeSlot.StartDateTime,
                    allDay: true,
                    deletable: !isOffDate && timeSlot.Employee != null,
                    endDateTime: timeSlot.EndDateTime,
                    description: isOffDate ? "Off Day" : description,
                    draggable: !isOffDate && timeSlot.Employee != null,
                    style: {
                        ...style
                    },
                    Employee: timeSlot.Employee ? {
                        Id: timeSlot.Employee.EmployeeID,
                        IcdOfficeID: timeSlot.Employee.IcdOfficeID
                    } : null
                }
            })
        };
    }

    function onChangeCalendar(calendar) {
        vm.calendar.startDate = calendar.startDate;
        vm.calendar.endDate = calendar.endDate;
        vm.calendar.mode = calendar.mode;
        const loaded = loadScheduleEvents().then(function () {
            return loadOfficeEmployees();
        }).then(function () {
            return loadRecentEmployees();
        });
        utilityService.showLoadingUntilResolved(loaded);
    }

    function onChangeSearchEmployee() {

        vm.employees = vm.pristineEmployees.filter(function (employee) {
            return utilityService.containsInvariant(employee.FirstName, vm.filters.employee) ||
                utilityService.containsInvariant(employee.LastName, vm.filters.employee) ||
                employee.IcdOffice &&
                utilityService.containsInvariant(employee.IcdOffice.IcdCorporationName, vm.filters.employee)
        });
        distributeEmployees();
        loadRecentEmployees();
    }

    function onChangeDivision() {
        reloadPageData();
        // Reload event host list passively.
        loadEventHosts();
    }

    function onChangeIcdOffice() {
        utilityService.showLoading();
        vm.loaded = false;
        loadScheduleEvents()
            .then(function () {
                return loadOfficeEmployees();
            }).then(function () {
                return loadRecentEmployees();
            }).catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                vm.loaded = true;
                utilityService.hideLoading();
            });
    }

    function onChangeFilters() {
        utilityService.showLoadingUntilResolved(
            loadScheduleEvents());
    }

    function onCreateTimeSlot(schedule, date, timeSlot) {
        const originalSchedule = vm.pristineScheduleEvents.filter(function (sch) {
            return schedule.id === sch.ScheduleEventID;
        })[0];
        if (originalSchedule) {
            if (!isWithinScheduleEventRange(originalSchedule, date)) {
                alert('Please drag into a valid time slot');
                return;
            }
            const timeSlots = getEmployeeTimeSlots(date, timeSlot.Employee.Id);
            if (timeSlots.length !== 0) {
                alert('Employee is already assigned to this date');
                return;
            }
            if (timeSlot.startDateTime && timeSlot.endDateTime) {
                createTimeSlot(schedule.id, timeSlot.startDateTime, timeSlot.endDateTime,
                    timeSlot.Employee.Id, timeSlot.Employee.IcdOfficeID);
            } else {
                createTimeSlot(schedule.id, moment(date).startOf("day").toDate(),
                    moment(date).endOf("day").toDate(), timeSlot.Employee.Id, timeSlot.Employee.IcdOfficeID);
            }
        }
    }

    function onMoveTimeSlot(oldValue, newValue) {
        //Date on which the moved time slot needs to be assigned
        const date = newValue.timeSlot.startDateTime;
        //Perviously assigned timeslot's date
        const oldDate = moment(oldValue.timeSlot.startDateTime);

        //Load old and new schedule from the memory
        const oldSchedule = vm.pristineScheduleEvents.filter(function (schedule) {
            return oldValue.schedule.id === schedule.ScheduleEventID;
        })[0];
        const newSchedule = vm.pristineScheduleEvents.filter(function (schedule) {
            return newValue.schedule.id === schedule.ScheduleEventID;
        })[0];

        if (oldSchedule && newSchedule) {
            //Reterive the time slot in order to get the employee assigned
            const timeSlot = oldSchedule.TimeSlots.filter(function (slot) {
                return slot.TimeSlotAssignmentID === oldValue.timeSlot.id
            })[0];
            if (timeSlot) {
                //Get all the time slots within the date range assigned to the moved timslot's employee (validation check)
                const timeSlots = getEmployeeTimeSlots(date, timeSlot.Employee.EmployeeID);
                //Move the time slot if the employee is not assigned on the new timeslot's date or if the pervious data
                //is same as the new timeslot's date
                if (timeSlots.length === 0 || oldDate.isSame(date)) {
                    //Move the time slot if the employee is not assigned on the new timeslot's date
                    if (!isWithinScheduleEventRange(newSchedule, date)) {
                        alert('Please drag into a valid time slot.');
                        return;
                    }
                    const assignmentRequest = {
                        ScheduleEventID: newSchedule.ScheduleEventID,
                        AssignScheduleEmployee: {
                            EmployeeID: timeSlot.Employee.EmployeeID,
                            IcdOfficeID: timeSlot.Employee.IcdOfficeID,
                            StartDate: moment(newValue.timeSlot.startDateTime).format(),
                            EndDate: moment(newValue.timeSlot.endDateTime).format(),
                        },
                        UnassignScheduleEmployee: {
                            ScheduleEventTimeSlotID: timeSlot.TimeSlotAssignmentID
                        }
                    };
                    moveTimeSlot(assignmentRequest);
                } else {
                    alert('Employee is already assigned to this date');
                }
            }
        }
    }

    function onDeleteTimeSlot(schedule, timeSlot) {
        if (!confirm("The employee will be unassigned from this timeslot.")) {
            return;
        }
        deleteTimeSlot(schedule.id, timeSlot.id);
    }

    function isOffDay(date, offDates) {
        let isOffDay = false;
        offDates.forEach(function (offDate) {
            if (moment(offDate).isSame(date)) {
                isOffDay = true;
            }
        });
        return isOffDay;
    }

    function generateQueryParameter() {
        const params = {
            StartDate: vm.calendar.startDate,
            EndDate: vm.calendar.endDate,
            DivisionID: vm.filters.division.Id,
            AssignedStatus: ScheduleEventAssignedStatus.Accepted,
            EventHostID: vm.filters.eventHost ? vm.filters.eventHost.EventHostID : null,
            IsAssigned: vm.filters.isAssigned,
            AssignedEmployees: vm.filters.employees && vm.filters.employees.length ?
                vm.filters.employees.map(p => p.Value) : null
        }
        return params;
    }

    function getEmployeeTimeSlots(date, employeeID) {
        const scheduleDate = moment(date).clone();
        const timeSlots = vm.pristineScheduleEvents.reduce((ag, event) => {
            const empTimeSlots = event.TimeSlots.filter(function (slot) {
                const startDate = moment(slot.StartDateTime).toDate();
                const endDate = moment(slot.EndDateTime).toDate();
                return slot.Employee != null && slot.Employee.EmployeeID === employeeID &&
                    scheduleDate.isBetween(startDate, endDate, null, "[]");
            });
            return ag.concat(empTimeSlots);
        }, []);
        return timeSlots;
    }

    function isWithinScheduleEventRange(scheduleEvent, date) {
        const startDate = moment(scheduleEvent.StartDate).clone();
        const endDate = moment(scheduleEvent.EndDate).clone();
        const scheduleDate = moment(date).clone();
        const isOffDate = isOffDay(scheduleDate, scheduleEvent.OffDates);
        return !isOffDate && scheduleDate.isBetween(startDate, endDate, null, "[]")
    }

    function createTimeSlot(scheduleID, start, end, employeeID, icdOfficeID) {
        const request = {
            AssignScheduleEmployee: {
                EmployeeID: employeeID,
                StartDate: moment(start).format(),
                EndDate: moment(end).format(),
                IcdOfficeID: icdOfficeID
            }
        };
        addEmployeeToRecents(employeeID)
        patchScheduleEvent(scheduleID, request);
    }

    function moveTimeSlot(assignmentRequest) {

        utilityService.showLoading();
        scheduleEventService.patchScheduleEvent(assignmentRequest.ScheduleEventID, assignmentRequest)
            .then(function () {
                utilityService.hideLoading();
                utilityService.showLoadingUntilResolved(loadScheduleEvents())
            }).catch(function (ex) {
                utilityService.hideLoading();
                console.error(ex);
                alert("Moving failed " + utilityService.getExceptionMessage(ex));
            });
    }

    function deleteTimeSlot(scheduleID, scheduleEventTimeSlotID) {
        const request = {
            UnassignScheduleEmployee: {
                ScheduleEventTimeSlotID: scheduleEventTimeSlotID
            }
        };
        patchScheduleEvent(scheduleID, request);
    }

    function patchScheduleEvent(scheduleID, request) {
        utilityService.showLoading();
        scheduleEventService.patchScheduleEvent(scheduleID, request)
            .then(function () {
                utilityService.hideLoading();
                utilityService.showLoadingUntilResolved(loadScheduleEvents())
            }).catch(function (ex) {
                utilityService.hideLoading();
                console.error(ex);
                alert("Assignment failed " + utilityService.getExceptionMessage(ex));
            })
    }

    function reloadPageData() {
        utilityService.showLoading();
        vm.loaded = false;
        vm.employees = [];
        loadIcdOffices()
            .then(loadScheduleEvents)
            .then(function () {
                return loadOfficeEmployees();
            }).then(function () {
                return loadRecentEmployees();
            }).catch(function (ex) {
                console.error(ex);
                alert("Initial load failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(function () {
                vm.loaded = true;
                utilityService.hideLoading();
            });
    }

    function createEmployeeOptions() {
        return {
            dataSource: {
                transport: {
                    read: e => employeeDataSourceRead(e)
                },
                serverFiltering: true,
            },
            dataTextField: 'Text',
            dataValueField: 'Value'
        };
    }

    function employeeDataSourceRead(e) {
        const preselected = vm.filters.employees || [];

        if (!vm.filters.icdOffice) {
            e.success(preselected);
            return;
        }

        const filter = e.data.filter;
        const searchFilter = filter ? filter.filters[0] : null;
        const searchValue = searchFilter ? searchFilter.value : "";

        let employees;
        const query = {
            FullName: searchValue,
            IcdOfficeID: vm.filters.icdOffice.Id,
            PageSize: searchValue.length < 3 ? 10 : null
        };
        if (searchValue.length < 3) {
            employees = employeeService.retrieveEmployeesPage(0, query)
                .then(page => page.Entities);
        } else {
            employees = employeeService.retrieveEmployees(query);
        }

        return employees.then(employees => employees.map(employee => ({
            Value: employee.Id,
            Text: `${employee.FirstName} ${employee.LastName}`
        }))
            .filter(p => !preselected.find(q => q.Value === p.Value)))
            .then(employees => {
                e.success(preselected.concat(employees));
            })
            .catch(ex => e.error(ex));
    }

    function onDragStart(event) {
        const data = JSON.parse(event.dataTransfer.getData("application/json"));
        const payloadData = data.payload ? data.payload.timeSlot : null;
        if (payloadData) {
            vm.pristineSchedules = angular.copy(vm.scheduleEvents);
            const schdedules = vm.scheduleEvents.map(function (event) {
                let isOfficeExists = false;
                const schedule = vm.pristineScheduleEvents.filter(function (sch) {
                    return event.id === sch.ScheduleEventID;
                })[0];
                if (schedule) {
                    isOfficeExists = schedule.ScheduleEventOffices.some(function (office) {
                        return office.IcdOfficeID === payloadData.Employee.IcdOfficeID
                            && office.AssignedStatus === ScheduleEventAssignedStatus.Accepted;
                    });
                }
                event.disabled = !isOfficeExists;
                return event;
            });
            vm.scheduleEvents = angular.copy(schdedules);
        }
    }

    function onDragEnd(event) {
        vm.scheduleEvents = Array.from(vm.pristineSchedules)
    }

    function addEmployeeToRecents(employeeID) {
        // Push the given corporation to the front of the recents list.
        /** @type {Array}  */
        let allRecents = JSON.parse(localStorage.getItem(recentsLocalStorageKey) || "[]");
        // Remove and add back to the front of the list.
        allRecents = allRecents.filter(p => p !== employeeID);
        allRecents.unshift(employeeID)
        localStorage.setItem(recentsLocalStorageKey, JSON.stringify(allRecents));
        loadRecentEmployees();
    }

    function loadRecentEmployees() {
        return $q.resolve()
            .then(() => {
                return JSON.parse(localStorage.getItem(recentsLocalStorageKey) || "[]");
            })
            .catch(() => []) // Non-crucial
            .then(allRecents => {
                updateRecentEmployees(allRecents, vm.employees);
            });
    }

    function updateRecentEmployees(allRecents, employees) {
        const emps = angular.copy(employees)
        const dict = emps.reduce((dict, emp) => {
            dict[emp.Id] = emp;
            return dict;
        }, {});
        vm.recentEmployees = allRecents.map(p => dict[p])
            .filter(p => p); // Ignore offices that weren't in the lookup
    }

}
